export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#8B4CD9',
    light: '#9b6ee4',
    contrastText: "#FFFFFF"
  },
  secondary: {
    main: '#003865',
    contrastText: '#0A5285',
    light: 'rgba(95, 141, 165, 0.1)'
  },
  text: {
    body: '#01284F',
    heading: '#25272C',
    questions: '#222222',
    primary: '#25272C',
    secondary: '#01284F',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    title: '#01284F',
    benefitSurface: '#22211F',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    aboutBenefits: '#D4CBFC',
    aboutBenefitsBorder: '#A390F8',
    aboutBenefitsDivider: 'rgba(255, 255, 255, 0.45)',
    aboutBenefitsOverlay: 'rgba(255, 255, 255, 0.6)',
    aboutBorder: '#EDEEF1',
    aboutContactDivider: '#D7DBE0',
    aboutFaq: '#FAF8FE',
    aboutHeroOverlay: 'rgba(242, 238, 253, 0.2)',
    aboutHowItWorks: '#FAFBFD',
    aboutPartnerIconBanner: '#F2EEFD',
    aboutPartners: '#FAFBFD',
    aboutStepDivider: 'rgba(139, 76, 217, 0.16)',
    brandTint: '#D4CBFC',
    brandTintSoft: '#F2EEFD',
    brandTintStrong: '#DDD5FC',
    howItWorksStepDivider: 'rgba(73, 81, 91, 0.25)',
    howItWorksStepConnector: 'rgba(139, 76, 217, 0.35)',
    howItWorksStepBadge: 'rgba(139, 76, 217, 0.12)',
    benefitHeroSurface: '#FCFCFF',
    benefitTableBorder: '#A390F8',
    benefitNetworkSurface: '#EEEAFE',
    benefitSurfaceBorder: '#D9DBE9',
    howItWorksHero: '#FCFCFF',
    plansHero: '#FCFCFF',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#9b6ee4',
    footer: '#002951',
    level2: '#8B4CD9',
    questions: '#F2EEFD',
    questionsDivider: 'rgba(139, 76, 217, 0.16)',
    level1: '#FAFBFC',
    tableHead: '#9b6ee4',
    tableSubhead: '#F2EEFD',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#9b6ee4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#00A1ED',
    secondary: '#F8D859',
    light: '#F3F6F9',
    hero: '#FBFCFE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)'
  },
  verticalBar: {
    used: '#0d9489',
    unused: '#9b6ee4',
    unlimited: '#C0C0C0',
  }
};
